import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-filter-calendar',
  templateUrl: './filter-calendar.component.html',
  styleUrls: ['./filter-calendar.component.scss']
})

export class FilterCalendarComponent {

  @Input() public filterForm: FormGroup;

  @Output() public sendCloseFilter = new EventEmitter<any>();
  @Output() public getFilter = new EventEmitter<any>();
  @Output() public emitForm = new EventEmitter<any>();
  @Output() public emitFilter = new EventEmitter<any>();
  @Output() public resetForm = new EventEmitter<any>();

  public isFormReset = false;

  public closeFilter(): void {
    if (this.alert()) {
      this.getFilter.emit(true);
    } else {
      this.getFilter.emit(false);
    }
    this.sendCloseFilter.emit(false);
  }

  public clearForm(): void {
    this.filterForm.reset();
    this.isFormReset = true;
  }

  public applyFilter(): void {
    if (this.isFormReset) {
      this.emitFilter.emit(false);
      this.getFilter.emit(false);
      this.emitForm.emit(true);
    } else {
      if (this.alert()) {
        this.emitFilter.emit(true);
        this.emitForm.emit(true);
      } else {
        this.emitForm.emit(false);
        this.emitFilter.emit(false);
      }
    }
    this.sendCloseFilter.emit(false);
  }

  public alert(): boolean {
    let flag = false;
    if (this.filterForm.get('key_event').value !== null ||
      this.filterForm.get('date_from').value !== null ||
      this.filterForm.get('date_to').value !== null ||
      this.filterForm.get('event').value === true ||
      this.filterForm.get('task').value === true ||
      this.filterForm.get('remember').value === true ||
      this.filterForm.get('return').value === true ||
      this.filterForm.get('visit').value === true) {
        flag = true;
    }
    return flag;
  }

}